<form [formGroup]="form"
      class="flex-col gap-16 container">
    <div class="flex-col gap-8">
        <label>{{ 'COMMON.NAME'|translate }} <span class="required">*</span></label>
        <input class="ui-input ui-input-40"
               formControlName="name">
    </div>

    <div formArrayName="validations"
         class="flex-col gap-16">
        @for(group of validations.controls; track group; let i = $index) {
        <div [formGroupName]="i"
             class="flex-row start-center gap-8">
            <input formControlName="path"
                   class="ui-input" />

            <mat-select formControlName="op"
                        class="ui-selector">
                @for(op of operators; track op) {
                <mat-option [value]="op">
                    {{ operatorsMap[op] }}
                </mat-option>
                }
            </mat-select>

            @if (group.get('op')?.value !== operatorsEnum.NotEmpty) {
            <input formControlName="value"
                   class="ui-input" />
            }

            <span class="ui-icon-close ui-icon-button"
                  (click)="removeValidation(i)">
            </span>
        </div>
        }
    </div>

    <ui-button (clickAction)="addValidation()"
               type="primary">
        Add validation
    </ui-button>
</form>